{
  "version": 1,
  "asset_id": "7cc5a392-a199-4bb5-ba13-f404afd62a50",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/7cc5a392-a199-4bb5-ba13-f404afd62a50/cursos-personas.webp",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/7cc5a392-a199-4bb5-ba13-f404afd62a50/cursos-personas.webp",
  "original_filename": "cursos-personas.webp",
  "size": 36840,
  "content_type": "image/webp",
  "created_at": "2026-07-24T15:29:56Z"
}
